<ng-content></ng-content>
<ng-template>
  <h3 mat-dialog-title>수강중인 학생들의 이메일을 클립보드에 복사하세요.</h3>
  <app-clipboard-copy [value]="Emails"></app-clipboard-copy>
</ng-template>




// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-group-mail-button/course-group-mail-button.component.html